import React from 'react'
import axios from 'axios'
import { List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup, 
TableContainer, Table, TableRow, TableHead, TableBody, TableCell, Paper, Pagination } from '@mui/material'
import { TextField, EditButton } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CommonDataGrid from '../common/DataGrid';
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'
import legolasApi from '../../api/legolas'

function ShipmentList() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [columnsOpen, setColumnsOpen]= React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    {id: 'incrementId', label: 'Shipment Number'},
    {id: 'orderId', label: 'Order ID'}, {id: 'awbNumber', label: 'AWB #'}, {id: 'customerId', label: 'Customer ID'},
    {id: 'shippingId', label: 'Shipping Partner'},
    {id: 'totalQuantity', label: 'Total Qty'}
  ])
  const [listData, setListData] = React.useState([])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalCount, setTotalCount] = React.useState(0)
  const [searchString, setSearchstring] = React.useState('')
  const allTableHeaders = [
    {id: 'incrementId', label: 'Shipment Number'},
    {id: 'orderId', label: 'Order ID'}, {id: 'awbNumber', label: 'AWB #'}, {id: 'customerId', label: 'Customer ID'},
    {id: 'shippingId', label: 'Shipping Partner'},
    {id: 'totalQuantity', label: 'Total Qty'}, {id: 'totalWeight', label: 'Total Weight'}
  ]

  React.useEffect(() => {
    const fetchAll = {}
    axios.post(`${legolasApi.url}/admin/shipments`, fetchAll).then(res => res.data).then(data => {
      // console.log('nani data.data', data)
      if (data.success) {
        setListData(data.data.data)
        setTotalCount(data.data.count)
      }
    })
  }, [searchString == ''])

  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleColumnClick = (e) =>  {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePagination = (event, value) => {
    console.log('Pagination value: ', value)
    axios.post(`${legolasApi.url}/admin/shipments?offset=${value-1}`).then((res) => {
      // console.log('nani res.data', res.data.data.data)
      const data = res.data.data.data, count = res.data.data.count
      setCurrentPage(value)
      setListData(data)
      setTotalCount(count)
    })
  }

  const handleSearch = () => {
    const searchQuery = { "orderId" : searchString }
    axios.post(`${legolasApi.url}/admin/shipments`, searchQuery).then((res) => {
      // console.log('admin/creditMemos res: ', res)
      const data = res.data.data.data, count = res.data.data.count
      setListData(data)
      setTotalCount(count)
    }).catch((error) => console.log('Error in getting shipments: ', searchQuery))
  }

  function findChecked(headerId, headerArr) {
    let checked = false
    // console.log('headerId :', headerId)
    // console.log('headerArr: ', headerArr)
    for (let i = 0; i< headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['id'] == headerId) {
        checked = true
        break
      }
    }
    return checked
  }

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel}
    const currentSelected = selectedHeaders
    currentSelected.push(headerObj)
    setColumnsOpen(false)
    setSelectedHeaders(currentSelected)
  }

  function resetTableHeaders() {
    setSelectedHeaders([
      {id: 'incrementId', label: 'Shipment Number'},
      {id: 'orderId', label: 'Order ID'}, {id: 'awbNumber', label: 'AWB #'}, {id: 'customerId', label: 'Customer ID'},
      {id: 'shippingId', label: 'Shipping Partner'},
      {id: 'totalQuantity', label: 'Total Qty'}, {id: 'totalWeight', label: 'Total Weight'}
    ])
    setColumnsOpen(false)
  }

  if (listData == []) return null
  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Shipments</Typography>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              {totalCount} record(s) found
            </Typography>
          </Box>
        </Box>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              margin: '0px 30px 10px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              } 
            }}>
              <Input
                type='search' 
                sx={{ border: '1px solid #2b3f7a', borderRadius: '20px' }} 
                endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
                placeholder='Seach by Order Id'
                onChange={(e) => setSearchstring(e.target.value)}
              />
            </Box>
        </Box>

        <Box>
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                {selectedHeaders.map((header) => [
                  <TableCell align='center'>{header.label}</TableCell>
                ])}
              </TableHead>
              <TableBody>
                {
                  listData.map(shipment => {
                    return (
                      <StyledTableRow>
                        <StyledTableCell align='center'>
                          {shipment.shipmentNumber}
                        </StyledTableCell>
                        <StyledTableCell align='center'>
                          {shipment.orderId}
                        </StyledTableCell>
                        <StyledTableCell align='center'>
                          {shipment.shipdetail ? shipment.shipdetail[0].tracking_number : null}
                        </StyledTableCell>
                        <StyledTableCell align='center'>
                          {shipment.customerId}
                        </StyledTableCell>
                        <StyledTableCell align='center'>
                          {shipment.shipdetail ? shipment.shipdetail[0].transporter : null}
                        </StyledTableCell>
                        <StyledTableCell align='center'>
                          {shipment.itemcount}
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Pagination count={Math.ceil(totalCount/50)} page={currentPage} onChange={handlePagination}/>
      </List>
    </React.Fragment>
  )
}

export default ShipmentList